import React, { useState, useEffect } from 'react';

import api from "../../../../../../services/api";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import Form from './Form'
import {
  Button,
  Row,
  Col,
  Modal,
} from "reactstrap";

import Filters from '../../../../../../components/Headers/Filters';

export default ({ notify, empresa, isActive, setHeaderContent, ...props }) => {

  const [pilares, setPilares] = useState([])

  const [showModal, setShowModal] = useState(false)

  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (isActive && setHeaderContent) {
      setHeaderContent(
        <Filters
            title={<h1 className="mb-0">Mídias sociais</h1>}
            onSearch={() => {}}
            onFiltersClead={() => setSearchTerm('')}
            presets={() => (
              <Button
                color="primary"
                type="button"
                className="btn-icon btn-3 ml-2"
                size="sm"
                onClick={() => setShowModal(true)}
              >
                <span className="btn-inner--icon">
                  <i className="ni ni-fat-add"></i>
                </span>
                <span className="btn-inner--text">Novo pilar</span>
              </Button>
            )}
        >
            <Row className="py-4">
                <Col md="12">
                   <div className="form-group mb-0">
                      <label className="form-control-label">Pesquisar</label>
                      <input
                        className="form-control"
                        placeholder="Pesquisar..."
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                   </div>
                </Col>
            </Row>
        </Filters>
      );
      return () => setHeaderContent(null);
    }
  }, [isActive, setHeaderContent, searchTerm]);
  const [pilarSelecionado, setPilarSelecionado] = useState(null)
  const [columns, setColumns] = useState([
    {
      dataField: 'acoes',
      formatter: (cell, row) => acoesFormatter(cell, row)
    },
    {
      dataField: 'nome',
      text: 'Nome',
      sort: true
    },
    {
      dataField: 'situacao',
      text: 'Situação',
      sort: true,
      formatter: (cell, row) => row.situacao == 'A' ? 'Ativo' : 'Inativo',
      align: 'center',
      headerAlign: 'center'
    },
    {
      dataField: 'descricao',
      text: 'Descricao',
    },
  ])

  useEffect(() => {
    if (pilares.length === 0) loadPilares()
  }, [])

  useEffect(() => {
    if (!showModal) {
      setPilarSelecionado(null)
    }
  }, [showModal])

  function acoesFormatter(cell, row) {
    return (<>
      <div class="btn-group" role="group" aria-label="Basic example">
        <Button
          className="btn-sm"
          color="secondary"
          onClick={() => edit(row.id)}
          outline>
          <i class="far fa-edit"></i>
        </Button>
      </div>
    </>)
  }

  function edit(pilarId) {
    setPilarSelecionado(pilarId)
    setShowModal(true)
  }

  function handleSavePilar() {
    notify('success', 'Pilar salvo')
    loadPilares()
    setShowModal(false)
  }

  async function loadPilares() {
    try {
      const response = await api.get(`/common/empresas/${empresa.id}/pilares`)
      if (response.data) {
        setPilares(response.data)
      }
    } catch (error) {
      console.log(error)
      notify('danger', 'Não foi possível carregar os pilares')
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center'
        }}
      >
        <Modal
          className="modal-dialog-centered"
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
        >
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {pilarSelecionado ? 'Alterar Pilar' : 'Novo Pilar'}
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setShowModal(!showModal)}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              notify={notify}
              pilarId={pilarSelecionado}
              onSuccess={handleSavePilar}
              close={() => setShowModal(false)}
              empresaId={empresa.id}
            />
          </div>
        </Modal>
      </div>
      <Row>
        <Col>
          <ToolkitProvider
            data={pilares}
            keyField="nome"
            columns={columns}
            search={{
              searchFormatted: true,
            }}
          >
            {props => {
              // Filtragem manual baseada no searchTerm projetado
              const filteredData = pilares.filter(p => 
                !searchTerm || 
                (p.nome && p.nome.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (p.descricao && p.descricao.toLowerCase().includes(searchTerm.toLowerCase()))
              );
              
              return (
                <div className="py-4">
                  <BootstrapTable
                    {...props.baseProps}
                    data={filteredData}
                    bootstrap4={true}
                    bordered={false}
                    classes="table-sm table-v-middle"
                    condensed
                  />
                </div>
              );
            }}
          </ToolkitProvider>
        </Col>
      </Row>
    </>
  );
}
